import React from "react";

interface Props {
  activeColor: string;
}

const LeadsIcon = ({ activeColor }: Props) => {
  return (
    <svg
  width="48"
  height="48"
  viewBox="0 0 48 48"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle cx="24" cy="24" r="22" fill="#EEF2FF"/>

  <g transform="translate(-2, 0) scale(1.1)">
    <path
      d="M18 16
         C16.5 17.5 16 19.5 17 22
         C18.5 25.5 22.5 29.5 26 31
         C28.5 32 30.5 31.5 32 30
         L29.5 27.5
         C29 27 28.2 26.8 27.6 27.1
         L25.5 28
         C24.5 28.4 23.4 28.2 22.6 27.4
         L20.6 25.4
         C19.8 24.6 19.6 23.5 20 22.5
         L20.9 20.4
         C21.2 19.8 21 19 20.5 18.5
         L18 16Z"
      fill="#1E1B6A"
    />
  </g>

  <path
    d="M30 17C33 19 34.5 22 34 25"
    stroke="#1E1B6A"
    strokeWidth="2"
    strokeLinecap="round"
  />
  <path
    d="M28 19C30 20.5 31 22.5 30.5 24"
    stroke="#1E1B6A"
    strokeWidth="2"
    strokeLinecap="round"
  />
</svg>
  );
};

export default LeadsIcon;
